import en from "@/assets/locales/en.json";

export const locales = {
  en
};

export type Locales = keyof typeof locales;
